import Vue from 'vue'
import TheUser from 'oderon-vue/auth/TheUser'
import { isFunction } from 'oderon-commons/src/is'
import { savePref, getPref } from 'oderon-vue/Prefs'

function item(label, to, opts = {}) {
  opts.label = label
  if (isFunction(to)) opts.onClick = to
  else opts.to = to
  return opts
}

function submenu(label, subitems) {
  return { label, subitems }
}

export default new Vue({
  computed: {
    // Ícone da raposa
    homeItem() {
      return item('Filas', '/health/queues')
    },

    // Barra principal (pode conter itens raiz e submenus)
    mainItems() {
      if (this.profile == 'billing') {
        return [
          item('Clientes', '/customers/list'),
          item('Centros de Custo', '/billing/cost-centers'),
          item('Pessoas', '/tools/gateman/accounts'),
          submenu('Histórico', [
            item('Instalação Módulos', '/tools/history'),
            item('Instalação Câmeras', '/history/cameras')
          ]),
          // item('Histórico', '/tools/history'),
          // submenu('Cadastros', [item('Contas', '/tools/gateman/accounts')]),
          submenu('Medições', [
            // item('de Serviços', '/billing/items'),
            // item('de Centros de Custo', '/billing/measure-v2'),
            // { isDivider: true },

            item('Responsáveis', '/setup/vehicle-owners'),
            { isDivider: true },
            item(
              'Saúde das Medições',
              '/billing/multiproduct/health'
            ),
            { isDivider: true },
            item(
              'MultiProduto - Centros de Custo',
              '/billing/multiproduct/cost-center'
            ),
            item(
              'MultiProduto - Autorizados',
              '/billing/multiproduct/technician'
            )
          ])
        ]
      }

      if (this.profile == 'support') {
        return [
          item('Tarefas', '/tools/tasklist'),
          item('Organizações', '/orgs'),
          item('Clientes', '/customers/list'),
          item('Base Instalada', '/installed-base'),
          item('Filas', '/health/queues'),
          item('Saúde', '/health/clients'),
          submenu('Setup', [
            item('Firmwares', '/setup/firmwares'),
            item('Autorizados', '/setup/technicians'),
            item('Marcas/Modelos', '/setup/brand-models'),
            item('Estoques', '/setup/depots')
          ]),
          submenu('Ferramentas', [
            item('Accounts', '/tools/gateman/accounts'),
            item('Subscriptions', '/beeper/subscriptions'),
            item('Beeper', '/beeper/sources'),
            { isDivider: true },
            item('Busca em Histórico de Módulos', '/tools/history'),
            item('Busca em Histórico de Objetos', '/tools/paperman'),
            item('Busca em Histórico de Eventos', '/tools/rd-events-history'),
            item('Busca em FW Updates', '/tools/fwupdates')
          ])
        ]
      }

      return [
        item('Tarefas', '/tools/tasklist'),
        item('Base Instalada', '/installed-base'),
        item('Filas', '/health/queues'),
        item('Saúde', '/health/clients'),
        submenu('Setup', [
          item('Organizações', '/orgs'),
          item('SysConfigs', '/setup/sysconfigs'),
          item('Firmwares', '/setup/firmwares'),
          item('SIM Cards', '/setup/sim-cards'),
          item('Câmeras JIMI', '/setup/cameras'),
          item('Teclados Checklist', '/setup/keyboards'),
          item('Autorizados', '/setup/technicians'),
          item('Marcas/Modelos', '/setup/brand-models'),
          item('Estoques', '/setup/depots'),
          { isDivider: true },
          item('Audio Messages', '/setup/audio/messages'),
          item('Audio Sets', '/setup/audio/sets'),
          item('Screen Sets', '/setup/screen-sets'),
          item('Dicionários CAN', '/setup/can-dicts'),
          item('Wifi ─ Redes', '/setup/wifi/networks'),
          item('Wifi ─ Sets', '/setup/wifi/sets')
        ]),
        submenu('Ferramentas', [
          item('Rawdata Inspector', '/rawdata/inspector'),
          item('Rawdata Parser', '/rawdata/parser'),
          item('Rawdata Writer', '/rawdata/writer'),
          item('CAN Sniffer', '/tools/can-sniffer'),
          { isDivider: true },
          item('Beeper', '/beeper/sources'),
          { isDivider: true },
          item('Busca em Histórico de Módulos', '/tools/history'),
          item('Busca em Histórico de Objetos', '/tools/paperman'),
          item('Busca em Histórico de Eventos', '/tools/rd-events-history'),
          item('Busca em FW Updates', '/tools/fwupdates'),
          { isDivider: true },
          item('Redis Browser', '/tools/redis-browser'),
          { isDivider: true },
          item('Accounts', '/tools/gateman/accounts'),
          item('Subscriptions', '/beeper/subscriptions'),
          item('Gateman Tokens', '/tools/gateman/tokens'),
          { isDivider: true },
          item('Dashtest', '/tools/dashtest'),
          item('Diff', '/tools/diff-viewer'),
          item('Path Viewer', '/tools/paths-viewer'),
        ]),
        submenu('Billing', [
          item('Clientes', '/customers/list'),
          // item('Medição de Serviços', '/billing/items'),
          // item('Medição de Centro de Custo', '/billing/measure-v2'),
          // { isDivider: true },
          item('Centros de Custo', '/billing/cost-centers'),
          item('Responsáveis', '/setup/vehicle-owners'),
          { isDivider: true },
          item('Saúde das Medições', '/billing/multiproduct/health'),
          { isDivider: true },
          item(
            'MultiProduto - Centros de Custo',
            '/billing/multiproduct/cost-center'
          ),
          item('MultiProduto - Autorizados', '/billing/multiproduct/technician')
        ])
      ]
    },

    accountItems() {
      let icons = ['mdi-radiobox-blank', 'mdi-radiobox-marked']

      return [
        // item('Preferências', '/prefs/configs'),
        // { isDivider: true },
        item('Perfil Completo', () => this.switchProfile('default'), {
          icon: this.profile == 'default' ? icons[1] : icons[0]
        }),
        item('Perfil Billing', () => this.switchProfile('billing'), {
          icon: this.profile == 'billing' ? icons[1] : icons[0]
        }),
        item('Perfil Suporte', () => this.switchProfile('support'), {
          icon: this.profile == 'support' ? icons[1] : icons[0]
        }),
        { isDivider: true },
        item('Logout', () => TheUser.logout())
      ]
    }
  },
  data() {
    return { profile: 'default' }
  },
  created() {
    TheUser.on('afterWhoami', () => this.fetchMenuItems())
  },
  methods: {
    async fetchMenuItems() {
      // let user = TheUser.user
      // busca menu inteiro ou overrides
      this.profile = getPref('oderonAdminProfile', 'default')
    },

    switchProfile(p) {
      savePref('oderonAdminProfile', p)
      this.profile = p
    }
  }
})
